"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var st_1 = require("../../core/st/st");
var tsx_1 = require("./tsx");
var iattributes_1 = require("./interface/iattributes");
var type_object_1 = require("../../core/lang/type-object");
var type_undefined_1 = require("../../core/lang/type-undefined");
var dom_1 = require("./dom");
var merge_arrays_1 = require("../../core/lang/merge-arrays");
var merge_objects_1 = require("../../core/lang/merge-objects");
var irender_reason_1 = require("../component/interface/irender-reason");
var attr_1 = require("../component/trait/attr");
if (!st_1.st.renderer) {
    st_1.st.renderer = {
        IGNORED_ATTRIBUTES: [],
        renderInitial: function (virtualNode, parentDomElement) {
            return st_1.st.dom.createElementOrElements(virtualNode, parentDomElement);
        },
        patch: function (domElements, virtualElements, parent) {
            // comments and undefines can occur at any place dynamically
            virtualElements = tsx_1.filterCommentsAndUndefines(virtualElements);
            // length to walk is the bigger number of both lists (reality in DOM vs. virtual DOM)
            var maxLength = domElements.length > virtualElements.length ? domElements.length : virtualElements.length;
            // walk through max. possible  differences on this level of the subtree
            for (var i = 0; i < maxLength; i++) {
                // removeChild() called before and end of similarities is logically reached
                var domElement = domElements[i];
                var virtualElement = virtualElements[i];
                if (typeof virtualElement == type_undefined_1.TYPE_UNDEFINED && typeof domElement == type_undefined_1.TYPE_UNDEFINED) {
                    break;
                }
                if (typeof virtualElement === type_object_1.TYPE_OBJECT) {
                    st_1.st.renderer.patchElement(parent, domElement, virtualElement);
                }
                else {
                    st_1.st.renderer.patchTextNode(parent, domElement, virtualElement);
                }
            }
        },
        removeElement: function (parent, domElement) {
            parent.removeChild(domElement);
        },
        patchElement: function (parent, domElement, virtualElement) {
            // ignore this element and it's while sub-tree (allows for manually changed DOM sub-trees to be retained)
            if (domElement && domElement.nodeType != 3 /* not Text*/ && domElement[iattributes_1.NOVDOM_ATTRIBUTE_NAME])
                return;
            if (domElement && domElement.$stComponent) {
                domElement.$stComponent.onBeforePatchEl();
            }
            var created = false;
            var replaced = false;
            var removed = false;
            var changedAttribute = false;
            if (typeof virtualElement == type_undefined_1.TYPE_UNDEFINED && typeof domElement != type_undefined_1.TYPE_UNDEFINED) {
                // DOMElement existing but no such VirtualElement: Evict zombie node
                st_1.st.renderer.removeElement(parent, domElement);
                removed = true;
            }
            else if (typeof virtualElement != type_undefined_1.TYPE_UNDEFINED && typeof domElement == type_undefined_1.TYPE_UNDEFINED) {
                // VirtualElement exists but no DOMElement: Append node
                domElement = st_1.st.dom.createElement(virtualElement, parent);
                created = true;
            }
            else if (virtualElement.attributes.doRender || (typeof virtualElement != type_undefined_1.TYPE_UNDEFINED &&
                typeof domElement != type_undefined_1.TYPE_UNDEFINED &&
                (domElement.tagName || "").toUpperCase() !== st_1.st.dom.getTagToUse(domElement.$stComponent, virtualElement).toUpperCase())) {
                // DOMElement and VirtualElement existing but tagName differs: Replace node
                // also: DOMElement is a TextNode (typeof tagName == 'undefined') but VirtualElement is not
                domElement = st_1.st.dom.replaceElement(virtualElement, parent, domElement);
                replaced = true;
            }
            else {
                // DOMElement and VirtualElement are the same on index and tagName
                // but attributes might differ: May update attributes
                // this.updateAllAttributeEventListeners(virtualElement, domElement);
                // DOMElement might have attributes that differ from VirtualElement attributes
                // Replace attribute value then
                if (domElement.attributes) {
                    var attributes = Array.from(domElement.attributes);
                    for (var a = 0; a < attributes.length; a++) {
                        var attributeName = tsx_1.tsxToStandardAttributeName(attributes[a].name);
                        // ignored attributes
                        if (st_1.st.renderer.IGNORED_ATTRIBUTES.indexOf(attributeName) > -1)
                            continue;
                        if (!attributeName.startsWith(dom_1.ATTR_EVENT_LISTENER_PREFIX)) {
                            if (!virtualElement.attributes || !virtualElement.attributes[attributeName]) {
                                // ignore cases such as: id, class, style, tabindex or DOM transparent attributes
                                if (!(domElement.$stComponent && (st_1.st.dom.isStandardHTMLAttribute(attributeName) || attr_1.AttrTrait.getType(domElement.$stComponent, attributeName) === attr_1.AttrType.DOM_TRANSPARENT))) {
                                    // DOMElement has an attribute that doesn't exist on VirtualElement attributes anymore
                                    domElement.removeAttribute(attributeName);
                                    changedAttribute = true;
                                }
                            }
                            else if (domElement.getAttribute(attributeName) != virtualElement.attributes[attributeName]) {
                                if (attributeName === dom_1.LIST_KEY_ATTRIBUTE_NAME) {
                                    domElement = st_1.st.dom.replaceElement(virtualElement, parent, domElement);
                                    replaced = true;
                                }
                                else {
                                    // case: a component re-renders and it's values for standard HTML attributes did change
                                    // such as style, class etc. - the new values need to be merged in to reflect the state change in DOM
                                    if (domElement.$stComponent && st_1.st.dom.isStandardHTMLAttribute(attributeName)) {
                                        if (attributeName === dom_1.CLASS_ATTRIBUTE_NAME) {
                                            var mergeResult = merge_arrays_1.mergeArrays(domElement.$stComponent.INTERNAL[attributeName], virtualElement.attributes[attributeName]);
                                            st_1.st.dom.setAttribute(attributeName, mergeResult, domElement);
                                            changedAttribute = true;
                                        }
                                        else if (attributeName === dom_1.STYLE_ATTRIBUTE_NAME) {
                                            var mergeResult = merge_objects_1.mergeObjects(domElement.$stComponent.INTERNAL[attributeName], virtualElement.attributes[attributeName]);
                                            st_1.st.dom.setAttribute(attributeName, mergeResult, domElement);
                                            changedAttribute = true;
                                        }
                                        else {
                                            st_1.st.dom.setAttribute(attributeName, virtualElement.attributes[attributeName] || domElement.$stComponent.INTERNAL[attributeName], domElement);
                                            changedAttribute = true;
                                        }
                                    }
                                    else {
                                        // DOMElement attribute value differs from VirtualElement attribute: Update
                                        st_1.st.dom.setAttribute(attributeName, virtualElement.attributes[attributeName], domElement);
                                        changedAttribute = true;
                                    }
                                }
                            }
                        }
                    }
                }
                // VirtualElement might have additional attributes, DOMElement doesn't have atm
                if (!replaced && virtualElement.attributes) {
                    // update attributes
                    for (var attributeName in virtualElement.attributes) {
                        attributeName = tsx_1.tsxToStandardAttributeName(attributeName);
                        if (!attributeName.startsWith(dom_1.ATTR_DEBUG_PREFIX) &&
                            !attributeName.startsWith(dom_1.ATTR_EVENT_LISTENER_PREFIX) &&
                            virtualElement.attributes.hasOwnProperty(attributeName) &&
                            !domElement.hasAttribute(attributeName)) {
                            // DOMElement attribute value differs from VirtualElement attribute: Set
                            st_1.st.dom.setAttribute(attributeName, virtualElement.attributes[attributeName], domElement);
                            changedAttribute = true;
                        }
                    }
                }
                if (typeof domElement != type_undefined_1.TYPE_UNDEFINED && domElement.$stComponent) {
                    domElement.$stComponent.onAfterPatchEl();
                }
            }
            var hasChanged = created || removed || replaced || changedAttribute;
            // process children (recursion)
            // inner should only be patched if it is not a custom element and has no shadow DOM
            if (typeof domElement != type_undefined_1.TYPE_UNDEFINED && domElement.$stComponent) {
                // update slot children
                domElement.$stComponent.virtualNode = virtualElement;
                if (domElement.$stComponent.shouldRender(irender_reason_1.RenderReason.CHILDREN_UPDATE)) {
                    domElement.$stComponent.doRender();
                }
                return;
            }
            else {
                // must be a child or sub-child of a node with an $stComponent
                if (hasChanged) {
                    // @ts-ignore
                    domElement.$stComponentRef.INTERNAL.hasDOMChanged = true;
                }
            }
            // optimization: If freshly created, all children are already perfectly rendered
            // so no need to walk through all child nodes
            if (!created && !replaced) {
                // parent elements must be both existing
                if (typeof domElement != type_undefined_1.TYPE_UNDEFINED &&
                    typeof virtualElement != type_undefined_1.TYPE_UNDEFINED &&
                    // and at least the existing DOM subtree
                    // or the virtual DOM subtree must be given
                    ((domElement.childNodes && domElement.childNodes.length) ||
                        (virtualElement.children && virtualElement.children.length))) {
                    // recursive call with childNodes and virtualElement childNodes
                    st_1.st.renderer.patch(domElement.childNodes || [], virtualElement.children, domElement);
                }
            }
        },
        patchTextNode: function (parent, domElement, virtualElementTextContent) {
            var created = false;
            var replaced = false;
            var removed = false;
            var updated = false;
            // text node content
            if (typeof virtualElementTextContent == type_undefined_1.TYPE_UNDEFINED && typeof domElement != type_undefined_1.TYPE_UNDEFINED) {
                // DOMElement existing but no such VirtualElement: Evict zombie node
                parent.removeChild(domElement);
                removed = true;
            }
            else if (typeof virtualElementTextContent != type_undefined_1.TYPE_UNDEFINED && typeof domElement == type_undefined_1.TYPE_UNDEFINED) {
                // VirtualElement exists but no DOMElement: Append node
                if (parent.nodeType === Node.TEXT_NODE) {
                    parent.textContent += virtualElementTextContent;
                }
                else {
                    st_1.st.dom.createTextNode(virtualElementTextContent, parent);
                }
                created = true;
            }
            else if (typeof virtualElementTextContent != type_undefined_1.TYPE_UNDEFINED && typeof domElement != type_undefined_1.TYPE_UNDEFINED) {
                // TextNode is present on both sides but content might differ
                // update innerText
                if (domElement.nodeType === Node.TEXT_NODE) {
                    // DOMElement remains being a TextNode
                    // ...but has changed: Reflect the change
                    if (domElement.textContent !== virtualElementTextContent) {
                        domElement.textContent = virtualElementTextContent;
                        updated = true;
                    }
                }
                else {
                    // VirtualElement is a TextNode now but DOMElement is not: remove and replace
                    st_1.st.dom.replaceTextNode(virtualElementTextContent, parent, domElement);
                    replaced = true;
                }
            }
            if (created || replaced || removed || updated) {
                // @ts-ignore
                parent.$stComponentRef.INTERNAL.hasDOMChanged = true;
            }
        },
        setIgnoredAttributes: function (attributeNames) {
            var _a;
            (_a = st_1.st.renderer.IGNORED_ATTRIBUTES).push.apply(_a, attributeNames);
        }
    };
    if (!st_1.st.render) {
        // add render method for awaiting / initial rendering
        st_1.st.render = function (virtualNode, domNode) {
            if (domNode === void 0) { domNode = document.body; }
            return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (process.env.NDOE_ENV == 'development') {
                                // timeout warning flag
                                st_1.st.render._rendered = true;
                                if (!virtualNode.type || !virtualNode.attributes || !virtualNode.children) {
                                    st_1.st.error("Invalid virutal node: ", JSON.stringify(virtualNode));
                                    throw new Error("This virtual node does NOT look like one");
                                }
                            }
                            // wait for the DOM to become ready, then render (prevents errors if a novice calls st.render() before <body> exists)
                            return [4 /*yield*/, st_1.st.dom.isReady()];
                        case 1:
                            // wait for the DOM to become ready, then render (prevents errors if a novice calls st.render() before <body> exists)
                            _a.sent();
                            // render root element
                            st_1.st.renderer.renderInitial(virtualNode, domNode);
                            if (st_1.st.router) {
                                // all <Route>'s and <RouteList>'s are instantiated by now,
                                // start rendering routes
                                st_1.st.router.enable();
                            }
                            return [2 /*return*/];
                    }
                });
            });
        };
        if (process.env.NDOE_ENV == 'development') {
            setTimeout(function () {
                if (!st_1.st.render._rendered) {
                    st_1.st.warn("st.render(<SomeComponent />) has NOT been called in 100ms. Have you forgotten to add this call?");
                }
            }, 100);
        }
    }
}
//# sourceMappingURL=renderer.js.map